import type { AboutPage, WithContext } from 'schema-dts';

import { schemaOrganization, transcendDescription } from './consts';

export const aboutSchema: WithContext<AboutPage> = {
  '@context': 'https://schema.org',
  '@type': 'AboutPage',
  name: 'Transcend',
  about: transcendDescription,
  publisher: schemaOrganization,
  specialty: {
    '@type': 'Specialty',
    name: 'Data Privacy Infrastructure',
  },
};
